import { gsap } from 'gsap'
import getAgent from '@egjs/agent'

export class ImgStalker {
  constructor() {
    const isMobile = getAgent().isMobile
    if (isMobile) return
    const page = document.body
    const stalkerImgs = document.querySelectorAll('.js-stalker_img')
    const hoverElm = document.querySelectorAll('.js-cursor')
    const STALKER_SIZE_X = 445 / 2
    const STALKER_SIZE_Y = 297 / 2
    if (stalkerImgs.length === 0 || hoverElm.length === 0) return
    const handle = () => {
      page.addEventListener('mousemove', onMouseMove)
      for (let i = 0; i < hoverElm.length; i++) {
        hoverElm[i].addEventListener('mouseenter', (e) => {
          const target = e.currentTarget.getAttribute('data-target')
          const currentImg = document.getElementById(target)
          currentImg.classList.add('is-view')
        })
        hoverElm[i].addEventListener('mouseleave', (e) => {
          stalkerImgs.forEach((elm) => {
            elm.classList.remove('is-view')
          })
        })
      }
    }
    const onMouseMove = (e) => {
      gsap.to(stalkerImgs, 0.3, {
        x: e.clientX - STALKER_SIZE_X,
        y: e.clientY - STALKER_SIZE_Y,
        ease: 'none',
      })
    }
    handle()
  }
}
